export default "__VITE_ASSET__BsrKfFFe__"